import { getUserMenu } from '@/api/user.js';
import { constantRoutes } from '@/router';
const permission = {
  state: {
    routes: [],
    addRoutes: []
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      constantRoutes[1].children = routes
      state.routes = constantRoutes
    }
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit }) {
      return new Promise(resolve => {
        // 向后端请求路由数据
        getUserMenu().then(res => {
          const accessedRoutes = filterAsyncRouter(res.list)
          accessedRoutes.push({ path: '*', hidden: true })
          commit('SET_ROUTES', accessedRoutes)
          resolve(accessedRoutes)
        })
      })
    }
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  return asyncRouterMap.filter(route => {
    if (route.id) {
      delete route.id
    }
    if (route.pid || route.pid === 0) {
      delete route.pid
    }
    if (route.title) {
      delete route.title
    }
    if (route.component) {
      route.component = loadView(route.component)

    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
}

export const loadView = (view) => { // 路由懒加载
  return (resolve) => require([`@/views${view}`], resolve)
  // return () => import(`@/views${view}`)
}



export default permission
